import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { useLang } from "../context/LanguageContext";

export default function CapabilityFlow() {
  const { t } = useLang();
  const { nodes, eyebrow, title } = t.home.flow;

  return (
    <section className="relative py-24 lg:py-32" data-testid="capability-flow">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <Reveal className="text-center">
          <p className="font-mono text-[11px] sm:text-xs font-bold tracking-[0.3em] uppercase text-sovereign">{eyebrow}</p>
          <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-100">{title}</h2>
        </Reveal>

        <div className="mt-14 relative">
          <div className="absolute left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-sovereign/40 via-cobalt/30 to-sovereign/40 hidden sm:block" aria-hidden="true" />
          <div className="space-y-0">
            {nodes.map((n, i) => (
              <div key={i}>
                <Reveal delay={0.05}>
                  <motion.div
                    whileHover={{ scale: 1.02 }}
                    transition={{ type: "spring", stiffness: 300, damping: 22 }}
                    className={`relative sm:mx-auto sm:max-w-md glass p-5 sm:p-6 text-center ${i === 0 ? "border-sovereign/40 shadow-[0_0_40px_rgba(0,240,255,0.12)]" : ""}`}
                    data-testid={`flow-node-${i}`}
                  >
                    {i === 0 && (
                      <span className="absolute -top-1.5 left-1/2 -translate-x-1/2 w-3 h-3 bg-sovereign rounded-full radar-ring" aria-hidden="true" />
                    )}
                    <p className={`font-display font-bold tracking-tight ${i === 0 ? "text-lg sm:text-xl text-sovereign" : "text-sm sm:text-base text-slate-100"}`}>
                      {n.name}
                    </p>
                    <p className="mt-1.5 font-mono text-[10px] tracking-[0.22em] uppercase text-slate-500">{n.sub}</p>
                  </motion.div>
                </Reveal>
                {i < nodes.length - 1 && (
                  <div className="relative h-10 hidden sm:block" aria-hidden="true">
                    <span className="flow-pulse absolute left-1/2 -translate-x-1/2 w-1.5 h-1.5 bg-sovereign rounded-full shadow-[0_0_12px_rgba(0,240,255,0.9)]" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
